"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColor = void 0;
var Box_1 = __importDefault(require("@mui/material/Box"));
var styles_1 = require("@mui/material/styles");
var getColor = function (theme, color) {
    var _a;
    return ({
        neutral: theme.palette.neutral.contrastText,
        blue: (_a = theme.palette.azzurro) === null || _a === void 0 ? void 0 : _a.dark,
        pink: theme.palette.primary.main,
    }[color]);
};
exports.getColor = getColor;
var blockedProps = ['width', 'roundedCornerLeft', 'roundedCornerRight', 'hasWhiteBorder', 'color', 'opacity', 'size'];
exports.default = (0, styles_1.styled)(Box_1.default, {
    shouldForwardProp: function (prop) { return !blockedProps.includes(prop); },
})(function (_a) {
    var theme = _a.theme, width = _a.width, _b = _a.roundedCornerLeft, roundedCornerLeft = _b === void 0 ? false : _b, _c = _a.roundedCornerRight, roundedCornerRight = _c === void 0 ? false : _c, _d = _a.hasWhiteBorder, hasWhiteBorder = _d === void 0 ? false : _d, _e = _a.color, color = _e === void 0 ? 'neutral' : _e, _f = _a.opacity, opacity = _f === void 0 ? 1 : _f, _g = _a.size, size = _g === void 0 ? 'regular' : _g, _h = _a.align, align = _h === void 0 ? 'left' : _h;
    return ({
        width: width,
        flexGrow: width ? undefined : 1,
        height: size === 'regular' ? theme.spacing(3) : theme.spacing(5),
        borderRadius: 'none',
        borderTopRightRadius: roundedCornerRight ? 4 : 0,
        borderBottomRightRadius: roundedCornerRight ? 4 : 0,
        borderTopLeftRadius: roundedCornerLeft ? 4 : 0,
        borderBottomLeftRadius: roundedCornerLeft ? 4 : 0,
        backgroundColor: (0, exports.getColor)(theme, color),
        display: 'inline-flex',
        alignItems: 'center',
        color: theme.palette.common.white,
        borderRight: hasWhiteBorder ? "1px solid ".concat(theme.palette.common.white) : 'none',
        opacity: opacity,
        fontSize: size === 'regular' ? 12 : theme.typography.body1.fontSize,
        fontWeight: theme.typography.fontWeightMedium,
        padding: theme.spacing(0, 1),
        paddingRight: align === 'left' ? 0 : undefined,
        justifyContent: align === 'right' ? 'flex-end' : 'flex-start',
    });
});
